import React, { useState } from "react";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { BulkEdit } from "../../../../services/ProductService/AllProductList/AllProductServices";

const BulkEditModal = ({ isOpen, onClose,onSelectedIds }) => {
    const [selectedField, setSelectedField] = useState("");
    const [value, setValue] = useState("");

    const restrictedFields = ["Company ID"]; // List of non-editable fields

    const getLabel = (fieldValue) => {
        const fieldMap = {
          "p_id": "Product Id",
          "active": "Status",
          "name": "Product Name",
          "category_p": "Product Category",
          "p_hsn_code_no": "Product HSN Code",
          "is_verified": "Verified",
          "p_add_by": "Product Added By",
          "p_add_date": "Product Added Date",
          "p_add_time": "Product Added Time",
          "p_last_modified_by": "Product Last Modified By",
          "p_last_add_date": "Product Last Modified Date",
          "p_last_add_time": "Product Last Modified Time",
          "p_owner": "Product Owner",
          "p_recommended_for": "Product Recommended for",
          "tag": "Tags",
          "next_step": "Next Step",
          "default_unit": "Default Unit",
          "indicative_min_price": "Indicative Min Price",
          "indicative_max_price": "Indicative Max Price",
          "p_price": "Product Price",
          "p_old_price": "Product Old Price",
          "p_discount": "Product Discount",
          "production_capacity": "Production Capacity",
          "production_capacity_unit": "Production Capacity Unit",
          "present_stock_status": "Present Stock Status",
          "production_lead_time": "Production Lead Time",
          "min_order_quantity": "Minimum Order Quantity",
          "min_order_quantity_unit": "Minimum Order Quantity Unit",
          "p_life": "Product Life",
          "p_lifespan": "Product LifeSpan",
          "p_certification": "Product Certifications",
          "p_description": "Product Description",
          "p_varient": "Product Variants",
        };
        return fieldMap[fieldValue] || "Value"; // Default if not found
      };      

    const handleFieldChange = (e) => {
        setSelectedField(e.target.value);
        setValue(""); // Reset value when field changes
    };

    const handleUpdate = async() => {
        if (!restrictedFields.includes(selectedField)) {

            const data = {"product_ids": onSelectedIds ,"update_data": {[selectedField]: value}}

            try{
                await BulkEdit('PATCH',data)
                onClose();
            }catch(error){
                console.error(error);
                
            }  
        }   
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg p-5 w-2/5 shadow-lg">
                {/* Header */}
                <div className="flex items-start justify-between border-b rounded-xl">
                    <div className="flex flex-col">
                        <div className="flex items-center gap-2">
                            <AiOutlineInfoCircle className="text-gray-700 text-xl" />
                            <h2 className="text-lg font-semibold">Bulk Edit</h2>
                        </div>
                        <p className="text-gray-600 text-sm mb-3">
                            You can edit only one field at a time.
                        </p>
                    </div>
                    <button onClick={onClose} className="text-gray-500 font-bold hover:text-gray-700">
                        ✖
                    </button>
                </div>
                <label className="block text-left text-gray-700 font-medium mt-5">
                    Fields <span className="text-red-500">*</span>
                </label>
                <div className="relative mt-2">
                    <select
                        className="w-80 p-2 border rounded-md text-gray-700"
                        value={selectedField}
                        onChange={handleFieldChange}
                    >
                        {Object.entries({
                            'Product Id': 'p_id',
                            'Product Name': 'name',
                            'Product Category': 'category_p',
                            'Product HSN Code': 'p_hsn_code_no',
                            'Verified': 'is_verified',
                            'Product Added By': 'p_add_by',
                            'Product Added Date': 'p_add_date',
                            'Product Added Time': 'p_add_time',
                            'Product Last Modified By': 'p_last_modified_by',
                            'Product Last Modified Date': 'p_last_add_date',
                            'Product Last Modified Time': 'p_last_add_time',
                            'Product Owner': 'p_owner',
                            'Product Recommended for': 'p_recommended_for',
                            'Next Step': 'next_step',
                            'Default Unit': 'default_unit',
                            'Indicative Min Price': 'indicative_min_price',
                            'Indicative Max Price': 'indicative_max_price',
                            'Product Price': 'p_price',
                            'Product Old Price': 'p_old_price',
                            'Product Discount': 'p_discount',
                            'Production Capacity': 'production_capacity',
                            'Production Capacity Unit': 'production_capacity_unit',
                            'Present Stock Status': 'present_stock_status',
                            'Production Lead Time': 'production_lead_time',
                            'Minimum Order Quantity': 'min_order_quantity',
                            'Minimum Order Quantity Unit': 'min_order_quantity_unit',
                            'Product Life': 'p_life',
                            'Product LifeSpan': 'p_lifespan',
                            'Product Certifications': 'p_certification',
                            'Product Description': 'p_description',
                            'Product Varients': 'p_varient',
                        }).map(([label, value]) => (
                            <option key={value} value={value} className="py-2">{label}</option>
                        ))}
                    </select>
                </div>

                {/* Warning Message */}
                {restrictedFields.includes(selectedField) && (
                    <p className="text-red-500 text-sm mt-1">This field is not for bulk edit</p>
                )}

                {/* Input Field */}
                <label className="block text-left text-gray-700 font-medium mt-4">
                    Values <span className="text-red-500">*</span>
                </label>
                <input
                    type="text"
                    placeholder={selectedField ? `Enter ${getLabel(selectedField)}` : "Select a field first"}
                    className="w-80 mt-1 p-2 border rounded-md text-gray-700"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    disabled={restrictedFields.includes(selectedField)}
                />
                {/* Buttons */}
                <div className="flex justify-end gap-3 mt-5">
                    <button
                        className="px-4 py-2 border rounded-md text-gray-700 hover:bg-gray-100"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className={`px-4 py-2 rounded-md text-white ${restrictedFields.includes(selectedField)
                                ? "bg-gray-400 cursor-not-allowed"
                                : "bg-blue-500 hover:bg-blue-600"
                            }`}
                        onClick={handleUpdate}
                        disabled={restrictedFields.includes(selectedField)}
                    >
                        Update
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BulkEditModal;